import { both, pipe, toString, equals } from 'ramda';

import isObj from './isObj';

/**
 * Checks if input value is a native `Promise`.
 * The Promise object represents the eventual completion (or failure)
 * of an asynchronous operation, and its resulting value.
 *
 * @func isPromise
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.1.0|v2.1.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link https://promisesaplus.com/|Promises/A+}, {@link RA.isThenable|isThenable}
 * @example
 *
 * RA.isPromise(null); // => false
 * RA.isPromise(undefined); // => false
 * RA.isPromise([]); // => false
 * RA.isPromise(Promise.resolve()); // => true
 * RA.isPromise(Promise.reject()); // => true
 * RA.isPromise({ then: () => 1 }); // => false
 */
var isPromise = /*#__PURE__*/both(isObj, /*#__PURE__*/pipe(toString, /*#__PURE__*/equals('[object Promise]')));

export default isPromise;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isPromise.js
// module id = 756
// module chunks = 0